import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  Chip,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import FormCampaign from "../../components/FormCampaign";
import * as cookie from "../../helper/cookie";
import { mapActionsToProps as campaignAction } from "../../redux/campaigns";
import { mapActionsToProps as stageAction } from "../../redux/miniCrm/stage";
import { mapActionsToProps } from "../../redux/telesale/call";
import CampaignDialog from "./../../components/CampaignDialog";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import { mapActionsToProps as agent } from "./../../redux/agent";
import { mapActionsToProps as clickToCallAction } from "./../../redux/cloudPBX/clickToCall";
import { mapActionsToProps as outbountCallAction } from "./../../redux/cloudPBX/outboundCall";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3,
    color: "black !important",
  },
  disabled: {
    color: "#ff1744 !important",
  },
  label: {
    color: "black !important",
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  margin: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  export: {
    width: "90px",
    height: "35px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
    marginRight: "20px",
  },
});

const listCollumnsParcel = [
  { id: "no", numeric: true, disablePadding: false, label: "STT" },
  { id: "codeParcel", numeric: true, disablePadding: false, label: "Bưu gửi" },
];

class LogsCallTelesale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "processedAt DESC, createdAt DESC",
        where: {
          dateFrom: null,
          dateTo: null,
          // statusId: { "nlike": "pending" } // CVB-164
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalView: false,
      campaignConfig: false,
      openCampaignConfig: false,
      token: "",
      showFormCampaign: false,
      formResult: [],
      codeParcel: null,
      packages: [],
      pageParcel: 0,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.setState({ token: cookie.getCookie("access_token") });
    this.props.getReasonSelectList();
    // this.interval = setInterval(() => this.itemInit(), 1000);
  }

  // componentWillUnmount() {
  //     clearInterval(this.interval);
  // }

  listCollumns = [
    {
      id: "campaign",
      numeric: true,
      disablePadding: false,
      label: "Chiến dịch",
    },
    { id: "type", numeric: true, disablePadding: false, label: "Loại" },
    {
      id: "from",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại gọi",
    },
    {
      id: "contact",
      _attributes: "fullName",
      numeric: true,
      disablePadding: false,
      label: "Tên khách hàng",
    },
    {
      id: "contact",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại nhận",
    },
    {
      id: "stage",
      numeric: true,
      disablePadding: false,
      label: "Trạng thái khách hàng",
    },
    {
      id: "statusId",
      numeric: true,
      disablePadding: false,
      label: "Trạng thái tương tác",
    },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian khởi tạo",
    },
    {
      id: "recallTime",
      numeric: true,
      disablePadding: false,
      label: "Thời gian gọi lại",
    },
    { id: "note", numeric: true, disablePadding: false, label: "Ghi chú" },
    { id: "view", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaign.name":
            case "stageId":
            case "statusId":
            default: {
              if (key.startsWith("dateFrom") || key.startsWith("dateTo")) {
                if (key == "dateFrom") {
                  and.push({
                    processedAt: { gte: this.state.filters.where.dateFrom },
                  });
                  where.and = and;
                } else {
                  and.push({
                    processedAt: { lte: this.state.filters.where.dateTo },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countIl({ where: where });
    this.props.getListCall(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      },
      {
        include: [
          { relation: "campaign", scope: { fields: { id: true, name: true } } },
        ],
      }
    );
    this.props.getAllCampaigns();
    this.props.getListStage(filters.order, 999, null, null);
  }

  handleClose = () => {
    this.setState({ modalView: false });
  };

  openModalView = (item) => {
    let formResult = [];
    if (
      item &&
      item.contact.packages &&
      item.contact.packages.length &&
      item.contact.packages.filter((item) => item.code).length
    ) {
      this.setState({
        codeParcel: item.contact.packages.filter((item) => item.code).length
          ? item.contact.packages.filter((item) => item.code)[0].code
          : null,
      });
      item.contact.packages
        .filter((item) => item.code)
        .forEach((pk) => {
          if (pk.code) {
            formResult.push({
              code: pk.code,
              result: item.form,
            });
          }
        });
    } else {
      formResult =
        item.formResult.length &&
        item.formResult[0].questions &&
        item.formResult[0].questions.length
          ? item.formResult
          : item.formResult.length && !item.formResult[0].questions
          ? [
              {
                note: item.note ? item.note : "",
                questions: item.formResult,
              },
            ]
          : item.form
          ? [item.form]
          : [];
    }
    this.state.item = item;
    this.props.getOutboundCall(this.state.filters.order, null, null, {
      where: { logId: { like: item.id } },
    });
    this.setState({
      modalView: !this.props.outboundCallLoading,
      formResult:
        item.formResult.length &&
        item.formResult[0].result &&
        item.formResult[0].result.questions &&
        item.formResult[0].result.questions.length
          ? item.formResult
          : formResult,
      packages:
        item &&
        item.contact &&
        item.contact.packages &&
        item.contact.packages.length > 0
          ? item.contact.packages
          : null,
      customer: item.contact,
    });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = name.endsWith("Id") ? value : { like: value };
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (dateFrom) => {
    const { filters } = this.state;
    filters.where.dateFrom = datetimeHelper.toFormat(
      dateFrom,
      "YYYY-MM-DD HH:mm"
    );
    this.setState({ dateFrom });
  };

  handleDateChangeEnd = (dateTo) => {
    const { filters } = this.state;
    filters.where.dateTo = datetimeHelper.toFormat(dateTo, "YYYY-MM-DD HH:mm");
    this.setState({ dateTo });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  callNumber = (item) => {
    const { agentStatus } = this.props;
    this.props.handleClickToCall({
      interactivelogId: item.id,
      extensionId: agentStatus ? agentStatus.extensionId : null,
    });
  };

  handleChangeInteractiveLog = () => {
    const { id, note, stageId } = this.state.item;
    const { item } = this.state;
    if (id) {
      return (
        this.props.editInteractiveLog(id, { note: note }),
        this.props.changeStateInteractiveLog(
          id,
          item ? (item.id ? item.stageId : this.state.stageId) : null
        ),
        setTimeout(
          function () {
            this.setState({ modalView: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleChangeStage = () => {
    const { item } = this.state;
    this.props.changeStateInteractiveLog(
      item ? (item.id ? item.id : null) : null,
      item ? (item.id ? item.stageId : this.state.stageId) : null
    );
    setTimeout(
      function () {
        this.setState({ modalView: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  _exporter;
  export = () => {
    const { filters } = this.state;
    const where = {};
    const and = [];
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaign.name":
            case "stageId":
            case "statusId":
            default: {
              if (key.startsWith("dateFrom") || key.startsWith("dateTo")) {
                if (key == "dateFrom") {
                  and.push({
                    processedAt: { gte: this.state.filters.where.dateFrom },
                  });
                  where.and = and;
                } else {
                  and.push({
                    processedAt: { lte: this.state.filters.where.dateTo },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.exportInteractiveLog({ where: where });
    if (this.props.loadingExcel === undefined) {
      alert("Đang load dữ liệu, xin thử lại...");
    } else {
      this._exporter.save();
    }
  };

  handleShowFormCampaign = () => {
    this.setState({
      showFormCampaign: !this.state.showFormCampaign,
    });
  };

  handleChangePageParcel = (e, pageParcel) => {
    this.setState({
      pageParcel,
      totalParcel: pageParcel * 5,
    });
  };

  handleSelectParcel = (parcel) => {
    const element = document.getElementById("form-survey");
    element.scrollTop = 0;
    const { arrayTicket } = this.state;
    this.setState(
      {
        codeParcel: parcel.code,
      },
      () => {
        this.setState({
          infoTicket: arrayTicket
            ? arrayTicket.find(
                (val) =>
                  val.customFields.packageId + "" === this.state.codeParcel + ""
              )
            : null,
        });
      }
    );
  };

  render() {
    const {
      classes,
      listLogsCallTelesale,
      coutLogsCallTelesale,
      listCampaign,
      listStage,
      outboundCall,
      excel,
      reasonSelectList,
    } = this.props;
    const {
      id,
      name,
      note,
      providerId,
      filters,
      item,
      modalView,
      notes,
      token,
    } = this.state;
    const outboundCallResult =
      typeof outboundCall === "object"
        ? Object.keys(outboundCall).map((key) => outboundCall[key])
        : outboundCall;
    const listLogsCallTelesaleResult =
      typeof listLogsCallTelesale === "object"
        ? Object.keys(listLogsCallTelesale).map(
            (key) => listLogsCallTelesale[key]
          )
        : listLogsCallTelesale;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    const excelResult =
      typeof excel === "object"
        ? Object.keys(excel).map((key) => excel[key])
        : excel;
    let dataForm = [];
    let formSoft = [];
    if (item) {
      if (item.formResult.length !== 0) {
        for (const key in item.formResult) {
          if (item.formResult.hasOwnProperty(key)) {
            const element = item.formResult[key];
            for (const key in element) {
              if (element.hasOwnProperty(key)) {
                const item = element[key];
                dataForm.push(item);
              }
            }
          }
        }
        formSoft = item.formResult.sort(function (a, b) {
          return a.id - b.id;
        });
      }
    }

    const { formResult, codeParcel } = this.state;
    let array;
    if (codeParcel) {
      array = JSON.parse(JSON.stringify(formResult)).filter(
        (form) => form.code === codeParcel
      )[0];
    } else {
      array = JSON.parse(JSON.stringify(formResult));
    }

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tên chiến dịch"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.campaignId}
                          name="campaignId"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          {listCampaignResult
                            ? listCampaignResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Số điện thoại gọi"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={
                            filters.where.from ? filters.where.from.like : ""
                          }
                          name="from"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Số điện thoại nhận"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.to ? filters.where.to.like : ""}
                          name="to"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.dateFrom}
                          maxDate={new Date()}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeStart}
                          name="dateFrom"
                          keyboard
                          ampm={false}
                          mask={[
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            " ",
                            /\d/,
                            /\d/,
                            ":",
                            /\d/,
                            /\d/,
                          ]}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.dateTo}
                          maxDate={new Date()}
                          minDate={filters.where.dateFrom}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeEnd}
                          name="dateTo"
                          keyboard
                          ampm={false}
                          mask={[
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            " ",
                            /\d/,
                            /\d/,
                            ":",
                            /\d/,
                            /\d/,
                          ]}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Trạng thái tương tác"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.statusId}
                          name="statusId"
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          <MenuItem key="pending" value="pending">
                            pending
                          </MenuItem>
                          <MenuItem key="not-process" value="not-process">
                            not-process
                          </MenuItem>
                          <MenuItem key="processed" value="processed">
                            processed
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Trạng thái khách hàng"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.stageId}
                          name="stageId"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          {listStageResult
                            ? listStageResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid
                        item
                        md={3}
                        style={{ alignItems: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                        {/* {
                                                    this.state.campaignConfig == true ? (
                                                        <Fab
                                                            variant="extended"
                                                            color="primary"
                                                            className={classes.margin}
                                                            onClick={() => this.setState({ openCampaignConfig: true })}
                                                        >
                                                            <Icon className={classes.extendedIcon}>input</Icon>
                                                            Phân bổ chiến dịch
                                                </Fab>
                                                    ) : null
                                                } */}
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách lịch sử tương tác"
          items={listLogsCallTelesaleResult}
          rowsPerPage={filters.pageSize}
          count={coutLogsCallTelesale ? coutLogsCallTelesale : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleView={this.openModalView}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          callNumber={this.callNumber}
        />
        <Dialog
          open={modalView}
          title={`Lịch sử tương tác`}
          input={
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                xl={6}
                lg={6}
                style={{ padding: 5 }}>
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Chiến dịch"
                  className={classes.input}
                  disabled
                  value={item ? (item.campaign ? item.campaign.name : "") : ""}
                />
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Điện thoại viên thực hiện"
                  className={classes.input}
                  disabled
                  value={
                    item
                      ? Object.getOwnPropertyNames(item.agent).length !== 0 &&
                        item.agent.extension
                        ? item.agent.extension.name
                        : ""
                      : ""
                  }
                />
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Loại"
                  className={classes.input}
                  disabled
                  value={item ? item.type : ""}
                />
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Thời gian khởi tạo"
                  className={classes.input}
                  disabled
                  value={
                    item
                      ? datetimeHelper.toFormat(
                          item.createdAt,
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                xl={6}
                lg={6}
                style={{ padding: 5 }}>
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Tên khách hàng"
                  className={classes.input}
                  disabled
                  value={item ? `${item.contact.fullName}` : ""}
                />
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Số điện thoại người nhận"
                  className={classes.input}
                  disabled
                  value={item ? item.contact.phoneNumber : ""}
                />

                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Trạng thái tương tác"
                  className={classes.input}
                  disabled
                  value={item ? item.statusId : ""}
                />
                <TextField
                  id="outlined-full-width"
                  margin="normal"
                  label="Thời gian gọi lại"
                  className={classes.input}
                  disabled
                  value={
                    item
                      ? item.recallTime
                        ? datetimeHelper.toFormat(
                            item.recallTime,
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        : ""
                      : ""
                  }
                />
              </Grid>
              <TextField
                id="outlined-full-width"
                margin="normal"
                label="Địa chỉ"
                className={classes.input}
                disabled
                value={item ? (item.contact ? item.contact.address : "") : ""}
              />
              <Typography component="p" style={{ paddingTop: 15 }}>
                Tags:{" "}
                {item
                  ? item.contact.tags !== undefined
                    ? item.contact.tags.map((i) => {
                        if (i !== "") {
                          return <Chip label={i} className={classes.chip} />;
                        }
                      })
                    : ""
                  : ""}
              </Typography>

              <TextField
                id="outlined-full-width"
                margin="normal"
                label="Ghi chú"
                className={classes.input}
                value={item ? (item.id ? item.note : this.state.note) : null}
                name="note"
                onChange={
                  item
                    ? item.id
                      ? this.handleChangeTextEdit("note")
                      : this.handleChangeText("note")
                    : null
                }
              />

              <TextField
                id="outlined-full-width"
                margin="normal"
                label="Trạng thái tương tác"
                className={classes.input}
                value={
                  item ? (item.id ? item.stageId : this.state.stageId) : null
                }
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                name="stageId"
                onChange={
                  item
                    ? item.id
                      ? this.handleChangeTextEdit("stageId")
                      : this.handleChangeText("stageId")
                    : null
                }>
                {listStageResult
                  ? listStageResult.map((item, key) => {
                      return (
                        <MenuItem value={item.id} key={key}>
                          {item.name}
                        </MenuItem>
                      );
                    })
                  : null}
              </TextField>
              <Divider />

              <Divider />
              {outboundCallResult
                ? outboundCallResult.map((item, key) => {
                    return (
                      <FormGroup style={{ width: "100%" }}>
                        <Typography>Cuộc gọi {key + 1}</Typography>
                        <audio
                          ref="audio"
                          src={item.recordFile}
                          controls
                          autoPlay={false}
                          style={{ width: "100%", marginTop: 20 }}
                        />
                        <Grid container>
                          <Grid item md={6}>
                            <TextField
                              id="outlined-full-width"
                              margin="normal"
                              label="Thời gian gọi"
                              className={classes.input}
                              value={datetimeHelper.toFormat(
                                item.startedAt,
                                "YYYY-MM-DD HH:mm"
                              )}
                            />
                          </Grid>
                          <Grid item md={6}>
                            <TextField
                              id="outlined-full-width"
                              margin="normal"
                              label="Trạng thái"
                              className={classes.input}
                              value={item.status}
                            />
                          </Grid>
                        </Grid>
                      </FormGroup>
                    );
                  })
                : null}
            </Grid>
          }
          otherButton={
            <React.Fragment>
              <DialogActions>
                <Button onClick={this.handleClose} color="secondary">
                  Hủy
                </Button>
                <Button
                  onClick={this.handleShowFormCampaign}
                  color="primary"
                  variant="contained">
                  Thông tin
                </Button>
                <Button
                  onClick={this.handleChangeInteractiveLog}
                  color="primary"
                  variant="contained"
                  autoFocus>
                  Thực hiện
                </Button>
              </DialogActions>
            </React.Fragment>
          }
        />
        <Dialog
          open={this.state.showFormCampaign}
          title={`Thông tin khảo sát`}
          fullWidth
          maxWidth={"xl"}
          input={
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ValidatorForm ref="form" className={classes.form}>
                <Grid container spacing={16}>
                  {this.state.packages ? (
                    <Grid item xs={12} sm={12} md={6} xl={6} lg={6}>
                      <TableData
                        nameTable={`Danh sách bưu gửi`}
                        items={
                          this.state.customer && this.state.customer.packages
                            ? this.state.customer.packages
                                .filter((item) => item.code)
                                .slice(
                                  this.state.pageParcel * 5,
                                  (this.state.pageParcel + 1) * 5
                                )
                                .map((item, index) => {
                                  item.no =
                                    index + 1 + this.state.pageParcel * 5;
                                  item.codeParcel = item.code;
                                  return item;
                                })
                            : []
                        }
                        count={
                          this.state.customer && this.state.customer.packages
                            ? this.state.customer.packages.filter(
                                (item) => item.code
                              ).length
                            : 0
                        }
                        page={this.state.pageParcel}
                        rowItems={listCollumnsParcel}
                        handleChangePage={this.handleChangePageParcel}
                        handleSelectParcel={this.handleSelectParcel}
                        selectedParcel={this.state.codeParcel}
                        parcel={true}
                        rowsPerPage={5}
                        rowSelectData={[5]}
                        layout={6}
                      />
                    </Grid>
                  ) : null}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={this.state.packages ? 6 : 12}
                    xl={this.state.packages ? 6 : 12}
                    lg={this.state.packages ? 6 : 12}>
                    <div
                      className="scrollLayout"
                      id="form-survey"
                      style={{
                        overflowY: "scroll",
                        height: "450px",
                        overflowX: "hidden",
                      }}>
                      <FormControl
                        style={{ display: "flex", marginBottom: 15 }}>
                        {array &&
                        array.result &&
                        array.result.questions.length > 0
                          ? array.result.questions.map((question, index) => {
                              return (
                                <>
                                  <FormCampaign
                                    key={index}
                                    index={index}
                                    id={question.id}
                                    type={question.type}
                                    title={question.title}
                                    note={question.note}
                                    options={question.options}
                                    question={question}
                                    disabled={true}
                                    classes={classes}
                                    reasonSelectList={reasonSelectList}
                                    token={token}
                                    onUpdateSate={this.onUpdateSate}
                                    onUpdateComment={this.onUpdateComment}
                                    layout={12}
                                  />
                                </>
                              );
                            })
                          : array &&
                            array.length &&
                            array[0].questions &&
                            array[0].questions.length
                          ? array[0].questions.map((question, index) => {
                              return (
                                <FormCampaign
                                  key={index}
                                  index={index}
                                  id={question.id}
                                  type={question.type}
                                  title={question.title}
                                  note={question.note}
                                  options={question.options}
                                  question={question}
                                  classes={classes}
                                  reasonSelectList={reasonSelectList}
                                  token={token}
                                  onUpdateSate={this.onUpdateSate}
                                  onUpdateComment={this.onUpdateComment}
                                  layout={12}
                                  disabled={true}
                                />
                              );
                            })
                          : null}
                        {array &&
                        array.result &&
                        array.result.questions.length > 0 ? (
                          <TextValidator
                            id="outlined-full-width"
                            margin="normal"
                            label="Ghi chú chung"
                            variant="outlined"
                            disabled
                            InputProps={{
                              className: classes.input,
                            }}
                            value={array.note ? array.note : ""}
                            name="note"
                            multiline
                            rows={3}
                          />
                        ) : array &&
                          array.length &&
                          array[0].questions &&
                          array[0].questions.length ? (
                          <TextValidator
                            id="outlined-full-width"
                            margin="normal"
                            label="Ghi chú chung"
                            variant="outlined"
                            disabled
                            InputProps={{
                              className: classes.input,
                            }}
                            value={array[0].note ? array[0].note : ""}
                            name="note"
                            multiline
                            rows={3}
                          />
                        ) : null}
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
              </ValidatorForm>
            </MuiPickersUtilsProvider>
          }
          buttonExit={true}
          onClose={() =>
            this.setState({
              showFormCampaign: false,
              formResult: [],
              codeParcel: null,
              packages: [],
              pageParcel: 0,
            })
          }
        />
        <Dialog
          open={this.props.outboundCallLoading}
          title={<CircularProgress />}
        />
        <Dialog open={this.props.loadingExcel} title={<CircularProgress />} />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
        <CampaignDialog
          open={this.state.openCampaignConfig}
          onClose={() =>
            this.setState({ campaignConfig: false, openCampaignConfig: false })
          }
          // contactFileId={!!this.state.item ? this.state.item.id ? this.state.item.id : '' : ''}
          type="il"
          campaigns={true}
        />
      </React.Fragment>
    );
  }
}

LogsCallTelesale.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  coutLogsCallTelesale: state.call.count.count,
  listLogsCallTelesale: state.call.calls,
  loadingExcel: state.call.loadingExcel,
  excel: state.call.excel,
  loading: state.call.loading,
  listCampaign: state.campaign.allCampaign,
  listStage: state.stage.stages,
  agentStatus: state.agent.status,
  outboundCall: state.outBoundCall.outBound,
  outboundCallLoading: state.outBoundCall.loading,
  reasonSelectList: state.campaign.reasonSelectList,
});

const CampaignProps = connect(null, campaignAction)(LogsCallTelesale);
const StageAction = connect(null, stageAction)(CampaignProps);
const ClickToCall = connect(null, clickToCallAction)(StageAction);
const Agent = connect(null, agent)(ClickToCall);
const OutBound = connect(null, outbountCallAction)(Agent);
LogsCallTelesale = connect(mapStateToProps, mapActionsToProps)(OutBound);

export default withStyles(styles)(LogsCallTelesale);
